import { useEffect, useState } from 'react'
import { ProduitEditForm, ProduitAddForm } from '../../config';
import { getAllProduits } from '../../store/produitSlice';
import { useDispatch, useSelector } from 'react-redux';
import { PlusIcon } from '@heroicons/react/24/solid';
import ModalForm from '../../components/common/ModalForm';
import { getAllCategories, getAllFournisseurs } from '../../store/settingsSlice';
import FormProduit from './FormProduit';

function Product() {

    const { produitList, produitDetails } = useSelector((state) => state.produit);
    const { fournisseurList, categorieList } = useSelector((state) => state.settings);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [searchTermProduit, setSearchTermProduit] = useState("");
    const [selectedProduit, setSelectedProduit] = useState();
    const [tempsProduit, setTempsProduit] = useState();
    const [filteredProduits, setFilteredProduits] = useState([]);

    const [isProduitModifying, setIsProduitModifying] = useState(false);


    const [formControls, setFormControls] = useState(null);
    const [formTitle, setformTitle] = useState("Ajouter un fournisseur");


    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getAllFournisseurs());
        dispatch(getAllCategories());
        dispatch(getAllProduits());
        if (produitList && produitList.length > 0) {
            setSelectedProduit(produitList[0]);
        }

    }, [getAllProduits]);


    useEffect(() => {
        // Produit filter
        if (produitList && produitList.length > 0) {
            const filteredP = produitList.filter((product) =>
                product.designation.toLowerCase().includes(searchTermProduit.toLowerCase()));

            setFilteredProduits(filteredP);

            if (!isProduitModifying) {
                setSelectedProduit(filteredP[0]);
            }
            setIsProduitModifying(false);
        }



    }, [produitList, searchTermProduit]);

    const addField = (form) => {

        const formattedCategorieList = categorieList
            .filter((categorie) =>
                categorie.designation.startsWith("Produit") ||
                categorie.designation.startsWith("Cuisine")
            )
            .map((categorie) => ({
                id: categorie.id.toString(),
                label: categorie.designation,
            })).sort((a, b) => a.label.localeCompare(b.label));

        const formattedFournisseurList = fournisseurList.map((categorie) => ({
            id: categorie.id.toString(),
            label: categorie.nomcompagnie,
        })).sort((a, b) => a.label.localeCompare(b.label));

        // Mettez à jour le formulaire avec un nouveau champ pour la catégorie
        const updatedForm = [
            ...form.map((field) => ({ ...field })), // Copie chaque champ individuellement
            {
                label: "Catégorie",
                name: "categorieid",
                componentType: "select",
                options: formattedCategorieList,
            },

            {
                label: "Description",
                name: "description",
                componentType: "textarea",
                placeholder: "Entrez la description",
            },
            {
                label: "Fournisseur",
                name: "fournisseurid",
                componentType: "select",
                options: formattedFournisseurList,
            },
        ];

        // Définissez les contrôles du formulaire
        setFormControls(updatedForm);
    };


    const handleSearPchChange = (e) => {
        setSearchTermProduit(e.target.value);
    };


    function handleModal(formFourni) {

        let formToUse = [];

        switch (formFourni) {
            case 'ProduitAdd':
                formToUse = JSON.parse(JSON.stringify(ProduitAddForm));
                setformTitle("Ajouter un plat");
                break;

            case 'ProduitEdit':
                formToUse = JSON.parse(JSON.stringify(ProduitEditForm));
                setformTitle("Modifier un plat");
                break;

            default:
                formToUse = JSON.parse(JSON.stringify(ProduitAddForm));
                setformTitle("Ajouter un plat");
                break;
        }

        addField(formToUse);

        setIsModalOpen(true); // Ouvre le modal

    }


    const [activeTab, setActiveTab] = useState(0);
    const tabs = ["Details", "Fournisseurs", "Produits"];

    function formatPrice(price) {
        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }

    return (
        <div className="bg-gray-100">

            {/* Sales Overview */}
            <div className="card">

                {/* header */}
                <div className="flex flex-row justify-between card-header">
                    <h1 className="h6">Résumé des ventes des produits</h1>

                    <div className="flex flex-row justify-center items-center">

                        <a href="">
                            <i className="mr-6 fa-chevron-double-down fad"></i>
                        </a>

                        <a href="">
                            <i className="fa-ellipsis-v fad"></i>
                        </a>

                    </div>

                </div>
                {/* end header */}

                {/* body */}
                <div className="gap-6 grid grid-cols-2 lg:grid-cols-1 card-body">

                    <div className="px-8 py-4">
                        <h1 className="h2">150 337.50</h1>
                        <p className="font-medium text-black">Ventes du mois en KMF</p>

                        <div className="flex items-center mt-10 mb-2">
                            <div className="bg-green-200 mr-3 px-3 py-1 rounded text-green-900">
                                <i className="fa fa-caret-up"></i>
                            </div>
                            <p className="text-black"><span className="num-2 text-green-400"></span><span className="text-green-400">% more sales</span> in comparison to last month.</p>
                        </div>

                        <div className="flex items-center">
                            <div className="bg-red-200 mr-3 px-3 py-1 rounded text-red-900">
                                <i className="fa fa-caret-down"></i>
                            </div>
                            <p className="text-black"><span className="num-2 text-red-400"></span><span className="text-red-400">% revenue per sale</span> in comparison to last month.</p>
                        </div>

                        <a href="#" className="btn-shadow mt-6">view details</a>

                    </div>

                </div>
                {/* end body */}

            </div>
            {/* end Sales Overview */}

            {/* start numbers */}
            <div className="gap-6 grid grid-cols-5 xl:grid-cols-2">

                {/* card */}
                <div className="mt-6 card">
                    <div className="flex items-center card-body">

                        <div className="bg-indigo-600 mr-3 px-3 py-2 rounded text-white">
                            <i className="fa-wallet fad"></i>
                        </div>

                        <div className="flex flex-col">
                            <h1 className="font-semibold"><span className="num-2"></span> Sales</h1>
                            <p className="text-xs"><span className="num-2"></span> payments</p>
                        </div>

                    </div>
                </div>
                {/* end card */}

                {/* card */}
                <div className="mt-6 card">
                    <div className="flex items-center card-body">

                        <div className="bg-green-600 mr-3 px-3 py-2 rounded text-white">
                            <i className="fa-shopping-cart fad"></i>
                        </div>

                        <div className="flex flex-col">
                            <h1 className="font-semibold"><span className="num-2"></span> Orders</h1>
                            <p className="text-xs"><span className="num-2"></span> items</p>
                        </div>

                    </div>
                </div>
                {/* end card */}

                {/* card */}
                <div className="mt-6 xl:mt-1 card">
                    <div className="flex items-center card-body">

                        <div className="bg-yellow-600 mr-3 px-3 py-2 rounded text-white">
                            <i className="fa-blog fad"></i>
                        </div>

                        <div className="flex flex-col">
                            <h1 className="font-semibold"><span className="num-2"></span> posts</h1>
                            <p className="text-xs"><span className="num-2"></span> active</p>
                        </div>

                    </div>
                </div>
                {/* end card */}

                {/* card */}
                <div className="mt-6 xl:mt-1 card">
                    <div className="flex items-center card-body">

                        <div className="bg-red-600 mr-3 px-3 py-2 rounded text-white">
                            <i className="fa-comments fad"></i>
                        </div>

                        <div className="flex flex-col">
                            <h1 className="font-semibold"><span className="num-2"></span> comments</h1>
                            <p className="text-xs"><span className="num-2"></span> approved</p>
                        </div>

                    </div>
                </div>
                {/* end card */}

                {/* card */}
                <div className="xl:col-span-2 mt-6 xl:mt-1 card">
                    <div className="flex items-center card-body">

                        <div className="bg-pink-600 mr-3 px-3 py-2 rounded text-white">
                            <i className="fa-user fad"></i>
                        </div>

                        <div className="flex flex-col">
                            <h1 className="font-semibold"><span className="num-2"></span> memebrs</h1>
                            <p className="text-xs"><span className="num-2"></span> online</p>
                        </div>

                    </div>
                </div>
                {/* end card */}

            </div>
            {/* end nmbers */}

            <div className="flex sm:flex-row md:flex-col flex-1 gap-4 bg-gray-100 md:mt-16 py-6">


                <div className="col-span-1 bg-white p-6 border rounded">
                    <div className="grid grid-cols-8 mb-2 px-3 border-b">
                        <PlusIcon
                            onClick={() => {
                                setTempsProduit(selectedProduit);
                                setSelectedProduit(null);
                                handleModal('PlatAdd');
                            }}
                            title='Ajouter un plat'
                            className="col-span-1 pt-3 w-9 h-9 text-teal-400 cursor-pointer" />
                        <form action="" className="flex col-span-7">
                            <input
                                className="flex-1 p-3 focus:outline-none"
                                type="text"
                                placeholder="Recherche..."
                                value={searchTermProduit}
                                onChange={handleSearPchChange}
                            />
                        </form>
                    </div>

                    <div>
                        <h2 className="mb-4 font-bold text-lg">Menus</h2>
                        {/* item */}
                        <ul className="space-y-2 min-h-[610px] max-h-[610px] overflow-y-scroll">
                            {filteredProduits.map((plat) => (
                                <li className={`
                              flex flex-row items-center hover:bg-teal-500 active:bg-teal-500 px-3 py-2
                               text-gray-600 text-left text-sm hover:text-white duration-800 cursor-pointer
                               ${plat.id === selectedProduit?.id ? "bg-teal-500 text-white" : ""}
                               `} key={plat.id}

                                    onClick={() => {
                                        setSelectedProduit(plat);
                                        //handleModal('PlatEditForm');
                                        //setformTitle("Modifier le plat");
                                        //console.log(selectedProduit)
                                    }}
                                >
                                    {plat.designation}

                                </li>
                            ))}
                        </ul>

                        {/* end item */}
                    </div>
                </div>

                {/* Main Content */}
                <div className="flex flex-col flex-1 bg-white p-6 border rounded">
                    <div className="flex flex-col flex-1">
                        <div className="relative w-full">
                            {/* Tabs Header */}

                            {/* Tabs Content */}
                            <div className="p-4">
                                {/* Détails de la catégorie */}
                                {selectedProduit ? (
                                    <div className="flex-1 p-6 min-h-[540px] max-h-[540px] overflow-y-scroll">
                                        <div className="flex justify-between items-center mb-4">
                                            <h1 className="font-bold text-2xl">{selectedProduit.designation}</h1>
                                            <span
                                                className={`text-sm font-medium px-3 py-1 rounded ${selectedProduit.disable ? "bg-red-500 text-white" : "bg-green-500 text-white"
                                                    }`}
                                            >
                                                {selectedProduit.disable ? "Inactive" : "Active"}
                                            </span>
                                        </div>
                                        <div className="space-y-4 text-gray-600">
                                            <div className='flex justify-between border-y py-6'>
                                                <div>
                                                    <table>
                                                        <tbody>
                                                            <tr>
                                                                <td className='pr-3'><strong>Val en stock : </strong></td>
                                                                <td>{formatPrice(selectedProduit.valStock)} Kmf</td>
                                                            </tr>
                                                            <tr>
                                                                <td className='pr-3'><strong>Qt en stock : </strong></td>
                                                                <td>{formatPrice(selectedProduit.stockqty)} {selectedProduit.unite}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className='pr-3'><strong> Prix unitaire : </strong></td>
                                                                <td>{selectedProduit.prix} Kmf</td>
                                                            </tr>
                                                            <tr className={` ${selectedProduit.margeBrute < 0 ? "text-red-500" : "text-green-500"}`}>
                                                                <td className='pr-3'><strong>Prix de vente : </strong></td>
                                                                <td>{formatPrice(selectedProduit.prixVente)} Kmf</td>
                                                            </tr>
                                                            <tr className={` ${selectedProduit.margeBrute < 0 ? "text-red-500" : "text-green-500"}`}>
                                                                <td className='pr-3'><strong>Marge Brute: </strong></td>
                                                                <td>{formatPrice(selectedProduit.margeBrute)} Kmf</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div>
                                                    <img
                                                        className='rounded w-40 h-40 object-cover'
                                                        src={selectedProduit.photo} alt={selectedProduit.designation} />
                                                </div>
                                            </div>

                                            {selectedProduit.description && selectedProduit.description.split("\n").map((paragraph, index) => (
                                                <p key={index}>{paragraph}</p>
                                            ))}

                                        </div>
                                        {/* end Fournisseur */}

                                    </div>
                                ) : (
                                    <div className="flex-1 p-6 min-h-[500px] max-h-[500px] overflow-y-scroll">
                                        <p>Chargement des données...</p>
                                    </div>
                                )}
                                {/* Footer avec le bouton Modifier */}
                                <footer className="flex justify-between items-center p-4 border-t">
                                    <button
                                        onClick={() => {
                                            //handleDelete(selectedFournisseur.id);
                                        }}
                                        className="bg-red-500 hover:bg-red-600 px-4 py-2 rounded text-white transition"
                                    >
                                        Supprimer
                                    </button>

                                    <button
                                        onClick={() => {
                                            setSelectedProduit(selectedProduit);
                                            handleModal('PlatEditForm');
                                            setformTitle("Modifier le plat");
                                        }}
                                        className="bg-blue-500 hover:bg-blue-600 px-4 py-2 rounded text-white transition"
                                    >
                                        Modifier
                                    </button>
                                </footer>

                            </div>
                        </div>
                    </div>
                    <div className="flex justify-between card-footer">
                        <p>4.41 GB (25%) of 17 GB used Manage</p>
                        <p>Last account activity: 36 minutes ago</p>
                    </div>
                </div>


            </div>
            <ModalForm
                isOpen={isModalOpen}
                onClose={() => {
                    setIsModalOpen(false)
                    setSelectedProduit(tempsProduit)
                }}
                children={
                    <FormProduit
                        FormControls={formControls}
                        formTitle={formTitle}
                        isDataEdit={selectedProduit}
                        setIsModalOpen={setIsModalOpen}
                        onProductUpdated={(updatedProduct) => {
                            setIsProduitModifying(true);
                            setSelectedProduit(updatedProduct)
                        }
                        } // Ajout du callback
                    />
                }

            />
        </div>
    )
}

export default Product